import { render, staticRenderFns } from "./postulaciones.vue?vue&type=template&id=7d6c8008&"
import script from "./postulaciones.vue?vue&type=script&lang=js&"
export * from "./postulaciones.vue?vue&type=script&lang=js&"
import style0 from "./postulaciones.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports